module.exports = __webpack_public_path__ + "assets/images/project/pasir-ris-town/01.jpg?v=b4616fe8";